import(/* webpackMode: "eager" */ "/app/src/app/(home)/page.tsx");
